/* Svensk katalog for locale-no.js (del 10 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ha.dragWidth': 'Dra för att ändra bredd',
  'ha.changeWidth': 'Ändra bredd',
  'err.auth.required': 'Du måste logga in först.',
  'err.auth.emailNotVerified': 'Bekräfta din e-postadress först. Vi har skickat en länk till dig — öppna den och försök igen.',
  'err.auth.sessionRevoked': 'Sessionen har avslutats. Logga in igen.',
  'err.invoice.publicLinkExpired': 'Den här länken har gått ut. Be avsändaren skicka dokumentet igen.',
  'err.business.alreadyVerified': 'Detta företag är redan registrerat i Plumme. Be ägaren bjuda in dig.',
  'err.business.idPortenRequired': 'Logga in med ID-porten för att verifiera företaget.',
  'err.business.notAnAltinnActor': 'Du står inte som aktör för det här företaget i Altinn.',
  'err.business.altinnUnavailable': 'Kunde inte slå upp dina roller i Altinn just nu. Försök igen senare.',
  'err.email.invalid': 'Ange en giltig e-postadress.',
  'err.pf.notCreated': 'Skapa Privatekonomi innan du kopplar till ett hushåll.',
  'err.pf.noAccess': 'Du har inte åtkomst till den här Privatekonomi-klienten.',
  'err.household.alreadyLinked': 'Du är redan kopplad till ett hushåll.',
  'err.household.notLinked': 'Du är inte kopplad till ett hushåll.',
  'err.household.selfInvite': 'Du kan inte bjuda in dig själv.',
  'err.household.selfLink': 'Du kan inte koppla dig till dig själv.',
  'err.household.invitePending': 'Det finns redan en väntande inbjudan till den här e-postadressen.',
  'err.household.invalidResponse': 'Ogiltigt svar på inbjudan.',
  'err.household.inviteNotFound': 'Inbjudan finns inte.',
  'err.household.inviteOtherEmail': 'Inbjudan tillhör en annan e-postadress.',
  'err.household.inviteInactive': 'Inbjudan är inte längre aktiv.',
  'err.household.someoneLinked': 'En av användarna är redan kopplad till ett hushåll.',
  'err.household.cannotWithdraw': 'Du kan inte dra tillbaka den här inbjudan.',
  'err.business.missing': 'Aktivt företag saknas.',
  'err.business.notFound': 'Företaget finns inte.',
  'err.business.dataNotFound': 'Företagsdata finns inte.',
  'err.import.noAccess': 'Du har inte behörighet att importera bokföring för det här företaget.',
  'err.import.jobMissing': 'Importjobb saknas.',
  'err.import.jobNotFound': 'Importjobbet finns inte.',
  'err.import.packageMissingFile': 'Den sparade importen saknar filreferens. Ladda upp filerna igen.',
  'err.import.packageAlreadyCommitted': 'Samma uppsättning importfiler har redan importerats. Ta bort dubbletten i listan över sparade importpaket.',
  'err.import.packageActive': 'Det här är det aktiva importpaketet och kan inte tas bort. Ta bort ett äldre paket i stället.',
  'err.advisor.insightIncomplete': 'AI-rådet avbröts innan det var klart. Försök igen om en stund.',
  'err.advisor.insightUnavailable': 'SuperPlumma kunde inte ta fram ett säkert råd utifrån det här underlaget just nu.',
  'err.advisor.insightEmpty': 'SuperPlumma lyckades inte ta fram ett färdigt råd. Försök igen om en stund.',
  'err.import.notAnalyzed': 'Importjobbet måste vara analyserat innan det kan godkännas.',
  'err.import.noProposal': 'Importjobbet saknar underlagsförslag.',
  'err.pf.clientMissing': 'Privatekonomi-klient saknas.',
  'err.pf.clientNotFound': 'Privatekonomi-klienten finns inte.',
  'err.pf.notPersonalClient': 'Den här klienten är inte en privatekonomi-klient.',
  'err.pf.noValidFields': 'Inga giltiga privatekonomifält att spara.',
  'err.tx.pickAtLeastOne': 'Välj minst en transaktion.',
  'err.tx.maxBatch': 'Du kan flytta högst 200 transaktioner åt gången.',
  'err.tx.pickCategory': 'Välj kategori.',
  'err.tx.notFound': 'En eller flera transaktioner finns inte.',
  'err.tx.otherClient': 'Transaktionen tillhör inte den här klienten.',
  'err.statement.missing': 'Kontoutdrag saknas.',
  'err.statement.notFound': 'Kontoutdraget finns inte.',
  'err.account.pickOrCreate': 'Välj eller skapa konto.',
  'err.account.missing': 'Konto saknas.',
  'err.account.notFound': 'Kontot finns inte.',
  'err.account.hasTransactions': 'Kontot har importerade transaktioner. Ta bort kontoutdraget först.',
  'err.asset.missing': 'Tillgång saknas.',
  'err.asset.notFound': 'Tillgången finns inte.',
  'err.loan.missing': 'Lån saknas.',
  'err.loan.notFound': 'Lånet finns inte.',
  'err.assistant.emptyQuestion': 'Skriv en fråga först.',
  'err.assistant.tooLong': 'Meddelandet är för långt.',
  'err.assistant.conversationLimit': 'Samtalet har nått gränsen. Starta ett nytt samtal för att fortsätta.',
  'err.idporten.expired': 'ID-porten-token saknas eller har gått ut. Logga in med ID-porten igen.',
  'pref.title': 'Preferenser',
  'pref.sub': 'Justera aviseringar, språk, tema och standardarbetsflöde.',
  'pref.deadlineMail': 'E-postpåminnelser om frister',
  'pref.deadlineMailSub': 'Få e-post 7 dagar före momsfrister och 30 dagar före skattemelding, årsredovisning och aksjonærregisteroppgave. Gäller norska företag där du är ägare eller administratör.',
  'pref.deadlineMailNotManager': 'Du är inte ägare eller administratör i det här företaget, så du får inga påminnelser om frister för det.',
  'pref.language': 'Språk',
  'pref.languageSub': 'Ditt språk i alla företag. Andra användare behåller sitt språk. Redovisningsregler och valuta följer företagets land.',
  'pref.mascots': 'Maskotbilder',
  'pref.mascotsSub': 'Visa SuperPlumma och andra maskotar i appen.',
  'pref.theme': 'Tema',
  'pref.theme.light': 'Ljust',
  'pref.theme.dark': 'Mörkt',
  'pref.saved': 'Preferenserna har sparats',
  'set.transitionImport.title': 'Importera övergångsfil',
  'set.transitionImport.help': 'Använd SAF-T XML, Excel eller CSV med konto och antingen debet/kredit eller saldo med tecken. Filen behandlas som startsiffror eller ingående balans, inte som fullständig historik.',
  'set.transitionImport.choose': 'Välj fil',
  'set.transitionImport.readError': 'Kunde inte läsa övergångsfilen.',
  'set.transitionImport.summaryBalance': 'Läste {accounts} konton och {balanceLines} balansrader. Kontrollera siffrorna innan du sparar.',
  'set.transitionImport.summaryStartup': 'Läste {accounts} konton: {salesLines} intäktsrader, {costLines} kostnadsrader, utgående moms {outgoingVat} och ingående moms {incomingVat}. Kontrollera siffrorna innan du sparar.',
  'set.transitionImport.includeVat': 'Ta med momsbeloppen i en MVA-melding i Plumme',
  'set.transitionImport.includeVatHelp': 'Slå bara på detta om beloppen inte redan har rapporterats från det tidigare systemet. Annars räknas momsen två gånger.',
  'set.transitionImport.vatPeriod': 'Momsperiod som ska ta emot startsiffrorna',
  'set.transitionImport.chooseVatPeriod': 'Välj period',
  'set.transitionImport.chooseVatPeriodError': 'Välj vilken momsperiod startsiffrorna ska tas med i.',
  'set.transitionImport.vatFootnote': 'Startmoms sparas som övergångsunderlag. Den läggs bara till i en MVA-melding när du aktivt väljer perioden ovan.',
  'set.transitionImport.useSimple': 'Använd enkel övergång',
  'set.transitionImport.simpleTitle': 'De flesta bör använda en enkel övergång',
  'set.transitionImport.simpleHelp': 'Vid nytt räkenskapsår räcker vanligtvis ingående balans. Vid byte mitt i året kan du använda startsiffror. Båda kan fyllas i manuellt eller importeras från SAF-T eller råbalans under Bokföring.',
  'set.transitionImport.completeTitle': 'Fullständig historikimport är avancerad',
  'set.transitionImport.completeRisk': 'Exporter från andra bokföringssystem kan innehålla skillnader, brister eller korrigeringar som inte kan tolkas säkert.',
  'set.transitionImport.completeCheck': 'Kontrollera ingående balans, momsbelopp och inlämningsstatus mot det tidigare systemet och myndigheternas arkiv.',
  'set.transitionImport.completeKeep': 'Behåll den ursprungliga exporten och räkenskapsinformationen under hela arkiveringstiden.',
  'set.transitionImport.completeAccept': 'Jag förstår att importerade uppgifter måste kontrolleras innan jag rapporterar eller korrigerar något.',
  'set.transitionImport.error.noRows': 'Filen saknar saldorader.',
  'set.transitionImport.error.noAccount': 'Filen måste ha en kolumn för konto eller kontonummer.',
  'set.transitionImport.error.ambiguousAmount': 'Filen måste ha separata debet- och kreditkolumner, eller belopp tillsammans med en sidkolumn.',
  'set.transitionImport.error.notBalanced': 'Ingående balans balanserar inte. Debet {debit} och kredit {credit} måste vara lika.',
  'set.transitionImport.error.fileType': 'Välj SAF-T XML eller en CSV- eller textfil med råbalans.',
  'set.transitionImport.warning.noSaftBalances': 'Hittade inga kontosaldon i SAF-T-filen.',
  'set.transitionImport.warning.noBalances': 'Hittade inga saldon med belopp i filen.',
  'set.transitionImport.lineNote': 'Importerad från {source}',
  'set.transitionImport.note': 'Importerad från {source}. Kontrollera saldona mot det tidigare bokföringssystemet.',
  'set.transitionImport.accountName': 'Konto {account}',
  'set.transitionImport.sourceTrialBalance': 'råbalans',
  'set.transitionImport.yearMismatch': 'Filen gäller övergång till {detectedYear}, men startår är satt till {selectedYear}. Ändra startår eller välj rätt fil.',
  'importCompliance.warningTitle': 'Kontrollera importerade uppgifter',
  'importCompliance.warningBody': 'Uppgifterna har hämtats från ett annat bokföringssystem. Plumme kontrollerar att datan kan läsas och behandlas, men kan inte bekräfta att exporten är fullständig, att siffrorna är korrekta eller att uppgifterna har tagits emot av myndigheterna. Kontrollera mot det tidigare bokföringssystemet och myndigheternas arkiv om du är osäker.',
  'importCompliance.historicalTitle': 'Historiska år markeras som klara',
  'importCompliance.historicalBody': 'För fullständiga år äldre än i fjol ({years}) markeras bokslut och relevanta uppgifter som inlämnade. Importerade momsperioder markeras som inlämnade, men inte som betalda.',
  'importCompliance.previousTitle': 'Bekräfta status för {year}',
  'importCompliance.previousHelp': 'Vi antar inte att fjolåret är klart. Välj ”Osäker” om detta behöver kontrolleras; då hålls uppgiften öppen.',
  'importCompliance.question.yearClosing': 'Är bokslutet klart?',
  'importCompliance.question.taxReturn': 'Är skattemeldingen inlämnad?',
  'importCompliance.question.annualAccounts': 'Är årsredovisningen inlämnad?',
  'importCompliance.question.vatReturns': 'Är MVA-meldingene för de importerade perioderna inlämnade?',
  'importCompliance.selectStatus': 'Välj status',
  'importCompliance.yes': 'Ja',
  'importCompliance.no': 'Nej',
  'importCompliance.unknown': 'Osäker – håll öppen',
  'importCompliance.accept': 'Jag förstår att importerade siffror och historiska inlämningsstatusar måste kontrolleras mot det tidigare bokföringssystemet och myndigheternas arkiv.',
  'importCompliance.noPaymentAssumption': 'Betalningsstatus för moms antas inte bara för att en period är gammal.',
  'importCompliance.noticeTitle': 'Importerade uppgifter för {year}',
  'importCompliance.area.vat': 'MVA-meldingene',
  'importCompliance.area.tax': 'skattemeldingen',
  'importCompliance.area.annualAccounts': 'årsredovisningen',
  'importCompliance.area.yearClosing': 'bokslutet',
  'importCompliance.statusDelivered': '{area} står som {status} baserat på importvalet.',
  'importCompliance.statusOpen': '{area} har hållits öppen.',
  'importCompliance.statusNotApplicable': '{area} är inte markerad som inlämningspliktig för den här företagsformen.',
  'importCompliance.statusFiled': 'inlämnad',
  'importCompliance.statusClosed': 'klar',
  'importCompliance.noticeBody': 'Siffror och historiska statusar har hämtats från ett annat bokföringssystem. Plumme kan inte bekräfta att exporten är fullständig, att siffrorna är korrekta eller att uppgiften har tagits emot av myndigheterna. Kontrollera mot det tidigare bokföringssystemet och myndigheternas arkiv innan du gör ändringar eller lämnar in.',
  'importCompliance.understood': 'Jag förstår',
  'importOpen.title': 'Importerad reskontra',
  'importOpen.items': 'poster',
  'importOpen.customerInvoice': 'Faktura',
  'importOpen.supplierInvoice': 'Leverantörsfaktura',
  'importOpen.noDate': 'utan datum',
  'importOpen.due': 'Förfaller {date}',
  'importOpen.controlBasis': 'importerat kontrollunderlag',
  'importOpen.open': 'Importerad öppen post',
  'importOpen.partial': 'Delvis reglerad',
  'importOpen.settled': 'Reglerad',
  'importOpen.credit': 'Kredit / överbetalning',
  'importOpen.registerSettlement': 'Registrera reglering',
  'importOpen.dialogTitle': 'Registrera reglering av importerad post',
  'importOpen.amount': 'Reglerat belopp',
  'importOpen.date': 'Regleringsdatum',
  'importOpen.note': 'Anteckning (valfritt)',
  'importOpen.noPostingNotice': 'Regleringen bokförs mot valt bankkonto och importerad kund- eller leverantörsreskontra. Ingen ny intäkt, kostnad eller moms skapas.',
  'importOpen.settledToast': 'Regleringen har registrerats',
  'importOpen.reopenedToast': 'Den importerade posten har öppnats igen',
  'importOpen.error': 'Kunde inte uppdatera den importerade posten',
  'importOpen.reopen': 'Öppna igen',
  'importOpen.reopenTitle': 'Öppna importerad post igen',
  'importOpen.reopenWarning': 'Posten blir åter utestående, och den bokförda regleringen återförs på valt datum.',
  'inv.detail.overpaid': 'Överbetald',
  'inv.detail.customerOverpayment': 'Oklart tillgodo hos kunden',
  'inv.detail.registerExtraPayment': 'Registrera extra inbetalning',
  'inv.pay.overpaymentNote': 'Inbetalningen är {amount} högre än fakturans restbelopp. Hela beloppet registreras, och överskottet ligger kvar som oklart tillgodo på kunden.',
  'inv.overpayment.refund': 'Återbetala överbetalning',
  'inv.overpayment.allocate': 'Fördela överbetalning',
  'inv.overpayment.available': 'Tillgänglig ofördelad överbetalning: {amount}.',
  'inv.overpayment.source': 'Överbetalning från faktura',
  'inv.overpayment.allocations': 'Fördelningar av överbetalning',
  'inv.overpayment.receivedFrom': 'Mottagen från {document}',
  'inv.overpayment.allocatedTo': 'Fördelad till {document}',
  'inv.overpayment.refundNote': 'Återbetalning av kundöverbetalning',
  'inv.overpayment.allocationNote': 'Fördelad kundöverbetalning från {source}',
  'inv.overpayment.refunded': 'Överbetalningen har återbetalats',
  'inv.overpayment.allocated': 'Överbetalningen har fördelats',
  'inv.overpayment.reverseRefund': 'Återför återbetalning',
  'inv.overpayment.reverseAllocation': 'Återför fördelning',
  'inv.overpayment.notConnected': 'Återbetalning av överbetalning är inte ansluten till backend.',
  'inv.overpayment.noSource': 'Välj en faktura med tillgänglig överbetalning.',
  'inv.overpayment.refundFailed': 'Kunde inte återbetala överbetalningen.',
  'inv.overpayment.allocationFailed': 'Kunde inte fördela överbetalningen.',
  'inv.overpayment.reverseRefundFailed': 'Kunde inte återföra återbetalningen.',
  'inv.overpayment.reverseAllocationFailed': 'Kunde inte återföra fördelningen.',
  'sup.overpayment.invalidAmount': 'Ange ett giltigt belopp.',
  'sup.overpayment.refunded': 'Återbetalningen har registrerats.',
  'sup.overpayment.allocated': 'Överbetalningen har fördelats.',
  'sup.overpayment.failed': 'Kunde inte hantera överbetalningen.',
  'sup.overpayment.refundTitle': 'Återbetala leverantörsöverbetalning',
  'sup.overpayment.allocateTitle': 'Fördela leverantörsöverbetalning',
  'sup.overpayment.refundAction': 'Registrera återbetalning',
  'sup.overpayment.allocateAction': 'Fördela överbetalning',
  'sup.overpayment.source': 'Överbetalning från faktura',
  'sup.overpayment.amount': 'Belopp',
  'sup.overpayment.date': 'Datum',
  'sup.overpayment.bankAccount': 'Bankkonto',
  'sup.overpayment.reverseRefund': 'Återför återbetalning',
  'sup.overpayment.refundReversed': 'Återbetalningen har återförts.',
  'sup.overpayment.reverseRefundFailed': 'Kunde inte återföra återbetalningen.',
  'sup.overpayment.reverseAllocation': 'Återför fördelning',
  'sup.overpayment.allocationReversed': 'Fördelningen har återförts.',
  'sup.overpayment.reverseAllocationFailed': 'Kunde inte återföra fördelningen.',
  'settlement.linkExisting': 'Koppla befintlig kontering',
  'settlement.title': 'Koppla befintlig kontering',
  'settlement.noNewPosting': 'Kopplingen uppdaterar reskontran. Den skapar ingen ny kontering i huvudboken.',
  'settlement.noMatchesTitle': 'Inga möjliga träffar',
  'settlement.noMatchesText': 'Kontrollera att den fria konteringen använder kredit 1500 för vald kund eller debet 2400 för vald leverantör, och att beloppet inte redan är kopplat.',
  'settlement.exactMatch': 'Exakt beloppsträff',
  'settlement.manualPosting': 'Fri kontering',
  'settlement.customerInvoice': 'Kundfaktura',
  'settlement.supplierInvoice': 'Leverantörsfaktura',
  'settlement.noDate': 'Utan datum',
  'settlement.canLink': 'Kan kopplas: {amount} · Ledigt i konteringen: {available}',
  'settlement.amount': 'Belopp som ska kopplas',
  'settlement.amountTooHigh': 'Beloppet är högre än disponibelt belopp.',
  'settlement.linkSelected': 'Koppla valda',
  'settlement.linking': 'Kopplar…',
  'settlement.linkedOne': 'Konteringen är kopplad till den öppna posten.',
  'settlement.linkedMany': '{count} öppna poster är kopplade.',
  'settlement.cardTitle': 'Öppna poster kan kopplas',
  'settlement.cardText': 'Välj själv faktura och belopp. Ingenting regleras automatiskt.',
  'settlement.linkPosting': 'Koppla {voucher}',
  'settlement.linkFailed': 'Det gick inte att koppla konteringen.',
  'settlement.voucherNotFound': 'Hittade inte verifikationen som ska kopplas.',
  'settlement.actionHelp': 'Kopplar ett oanvänt belopp på en fri kontering till en öppen kund- eller leverantörspost utan att skapa en ny kontering i huvudboken.',
  'accounting.importedStatisticsTitle': 'Importerad redovisningsstatistik',
  'accounting.importedStatisticsReconciliation': 'Saldona kommer från kontrollerad importerad kontostatistik, inte från journalhändelser i Plumme. Avstämningen kan granskas, men certifiering och avslut är fortfarande spärrade.',
});
